import dayjs from 'dayjs'

export const normalizeTimestamp = (ts) => {
  if (!ts) return null

  const num = Number(ts)

  // < 1e12 ⇒ seconds
  return num < 1e12 ? num * 1000 : num
}

export const formatDate = (ts) =>
  ts ? dayjs(normalizeTimestamp(ts)).format('DD/MM/YYYY') : ''

export const mapSelectionByCategory = (source = [], configs = []) => {
  if (!Array.isArray(source)) return

  configs.forEach(({ category, setState }) => {
    if (typeof setState !== 'function') return

    const result = source
      .filter(
        (item) => item.category === category && item.value !== item.category // ⬅️ LOẠI BỎ CÁI TRÙNG
      )
      .map((item) => ({
        id: item.id,
        value: item.value,
        label: item.title
      }))

    setState(result)
  })
}
export const buildSubProductTypeFromCategory = (
  selectionList = [],
  categories = []
) => {
  const result = {}

  categories.forEach((cat) => {
    result[cat] = selectionList
      .filter((item) => item.category === cat)
      .map((item) => ({
        value: item.value,
        name: item.title,
        label: item.title
      }))
  })

  return result
}
export const getSubProductType = (value, data) => {
  const map = {
    1: { key: 'APARTMENT_BDS', list: data?.APARTMENT_BDS },
    2: { key: 'BUILDING_BDS', list: data?.BUILDING_BDS },
    3: { key: 'REAL_ESTATE_BDS', list: data?.REAL_ESTATE_BDS },
    4: { key: 'GROUND_BDS', list: data?.GROUND_BDS }
  }

  const group = map[value]
  if (!group) return []

  return (group.list || [])
    .filter((item) => String(item.value).trim() !== String(group.key).trim())
    .map((item) => ({
      ...item,
      value: item.value,
      label: item.name,
      name: item.name
    }))
}

export const formatCurrencyLabel = (value) => {
  const num = Number(value)
  if (isNaN(num)) return ''

  if (num >= 1_000_000_000) {
    const ty = num / 1_000_000_000

    // làm tròn tối đa 3 số thập phân, không dư số 0
    const formatted = parseFloat(ty.toFixed(3)).toString().replace('.', ',')

    return `${formatted} Tỷ`
  }

  if (num >= 1_000_000) {
    const trieu = num / 1_000_000
    const formatted = parseFloat(trieu.toFixed(3)).toString().replace('.', ',')
    return `${formatted} Triệu`
  }

  if (num >= 1_000) {
    const nghin = num / 1_000
    const formatted = parseFloat(nghin.toFixed(3)).toString().replace('.', ',')
    return `${formatted} Nghìn`
  }

  return `${num} Đồng`
}

export const formatMoney = (value) => {
  if (!value) return ''
  return value
    .toString()
    .replace(/\D/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const unFormatMoney = (value) => {
  if (!value) return ''
  return value.replace(/\./g, '')
}
